import React from 'react';
import { styles } from '../styles.ts';

interface HeaderProps {
  backendHealthy: boolean | null;
  backendUrl: string;
  setBackendUrl: (url: string) => void;
  activeTab?: 'editor' | 'skills';
  onTabChange?: (tab: 'editor' | 'skills') => void;
}

export function Header({ 
  backendHealthy, 
  backendUrl, 
  setBackendUrl,
  activeTab = 'editor',
  onTabChange
}: HeaderProps) {
  return (
    <header style={styles.header}>
      <div style={styles.logoGroup}>
        <div style={styles.badge}>Phase 1 R&D</div>
        <h1 style={styles.title}>Partial Design Generator</h1>
      </div>

      {onTabChange && (
        <div style={{ display: 'flex', gap: '8px', marginLeft: '20px' }}>
          <button
            onClick={() => onTabChange('editor')}
            style={{
              padding: '6px 14px',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
              border: activeTab === 'editor' ? '1px solid var(--accent)' : '1px solid #333',
              backgroundColor: activeTab === 'editor' ? 'rgba(156, 39, 176, 0.2)' : '#1e1e1e',
              color: activeTab === 'editor' ? '#ffffff' : '#9ca3af',
              transition: 'all 0.2s'
            }}
          >
            🎨 Návrh Místnosti & Chat
          </button>
          <button
            onClick={() => onTabChange('skills')}
            style={{
              padding: '6px 14px',
              borderRadius: '6px',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
              border: activeTab === 'skills' ? '1px solid var(--accent)' : '1px solid #333',
              backgroundColor: activeTab === 'skills' ? 'rgba(156, 39, 176, 0.2)' : '#1e1e1e',
              color: activeTab === 'skills' ? '#ffffff' : '#9ca3af',
              transition: 'all 0.2s'
            }}
          >
            🧠 Agent Skills Library
          </button>
        </div>
      )}

      <div style={styles.healthStatus}>
        <span style={{ 
          ...styles.dot, 
          backgroundColor: backendHealthy === true ? 'var(--success)' : (backendHealthy === false ? '#ef4444' : '#f59e0b') 
        }} />
        <span style={styles.statusText}>
          Backend: {backendHealthy === true ? 'Connected' : (backendHealthy === false ? 'Disconnected' : 'Checking...')}
        </span>
        <input 
          type="text" 
          value={backendUrl} 
          onChange={(e) => setBackendUrl(e.target.value)} 
          style={styles.urlInput}
        />
        <a 
          href={`${backendUrl}/chatbot-doc`} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="readme-btn"
          style={{
            borderColor: 'rgba(156, 39, 176, 0.4)',
            color: '#e1bee7'
          }}
        >
          💬 CHATBOT.md
        </a>
        <a 
          href={`${backendUrl}/zoning-doc`} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="readme-btn"
          style={{
            borderColor: 'rgba(59, 130, 246, 0.3)',
            color: '#93c5fd'
          }}
        >
          📐 ZONING.md
        </a>
        <a 
          href={`${backendUrl}/readme`} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="readme-btn"
        >
          📖 README.md
        </a>
      </div>
    </header>
  );
}

